import { sentenceCase } from "change-case";
import styled from "styled-components";

import { Filter } from "pages/Strombestilling/components/Filter";
import { FilterTableRoot } from "pages/Strombestilling/components/OrderFilterTable";

const Root = styled(FilterTableRoot)`
	width: 8rem;
`;

const options: Map<string, string> = new Map([
	["Fullført", "completed"],
	["Pågår", "due"],
	["Avsluttet", "ghost"],
]);

export function PurreFilter({ selected, setSelected }: { readonly selected: string | null; readonly setSelected: (newValue?: string) => void }) {
	return (
		<Root>
			<thead>
				<tr>
					<th>Purring</th>
				</tr>
			</thead>
			<tbody>
				{Array.from(options.entries()).map(([k, v]) => (
					<tr key={k}>
						<td>
							<Filter onClick={() => setSelected(selected === v ? undefined : v)}>{sentenceCase(k)}</Filter>
						</td>
					</tr>
				))}
			</tbody>
		</Root>
	);
}
